import * as Sentry from "@sentry/react";

// Client-side error tracking — no-ops if REACT_APP_SENTRY_DSN isn't set,
// same pattern as App Check's siteKey check in lib/firebase.js. Unlike App
// Check, this warns loudly on a production build so a missing DSN doesn't
// silently ship with zero error visibility.
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({ dsn, environment: process.env.NODE_ENV });
} else if (process.env.NODE_ENV === "production") {
  console.warn("REACT_APP_SENTRY_DSN is not set — browser errors will not be reported.");
}
